export const settingMenus = () => ({
    Id: 14,
    id: `main-menu-2-all`,
    path: '/management/settings/catalog',
    label: 'Settings',
    Description: 'Settings panel enables the user to configure the appearance or actions in an platform..',
    isEnabled: true,
    svg: (
        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="9" fill="none" stroke="#ffffff" strokeWidth="2" />
            <path d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" fill="#ffffff" />
            <path d="M22 12c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z" fill="#ffffff" />
        </svg>
    ),
    subMenu: [
        // {
        //     id: `coln-1-collections`,
        //     label: 'Catalog Settings',
        //     path: '/management/settings/catalog',
        //     isEnabled: true,
        //     svg: (
        //         <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        //             <circle cx="12" cy="12" r="9" fill="none" stroke="#007BFF" strokeWidth="2" />
        //             <path d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" fill="#007BFF" />
        //             <path d="M22 12c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z" fill="#007BFF" />
        //         </svg>
        //     ),
        // },
        {
            id: `coln-1-collections`,
            label: 'ONE Settings',
            path: '/management/settings/one',
            isEnabled: true,
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="9" fill="none" stroke="#007BFF" strokeWidth="2" />
                    <path d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" fill="#007BFF" />
                    <path d="M22 12c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z" fill="#007BFF" />
                </svg>
            ),
        },
        {
            id: `coln-1-collections`,
            label: 'CRM Settings',
            path: '/management/settings/crm',
            isEnabled: true,
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="9" fill="none" stroke="#007BFF" strokeWidth="2" />
                    <path d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" fill="#007BFF" />
                    <path d="M22 12c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z" fill="#007BFF" />
                </svg>
            ),
        },
        // {
        //     id: `coln-1-collections`,
        //     label: 'DOM Settings',
        //     path: '/management/settings/dom',
        //     isEnabled: true,
        //     svg: (
        //         <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        //             <circle cx="12" cy="12" r="9" fill="none" stroke="#007BFF" strokeWidth="2" />
        //             <path d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" fill="#007BFF" />
        //             <path d="M22 12c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z" fill="#007BFF" />
        //         </svg>
        //     ),
        // },
        {
            id: `coln-1-collections`,
            label: 'Marketing Settings',
            path: '/management/settings/marketing',
            isEnabled: true,
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="9" fill="none" stroke="#007BFF" strokeWidth="2" />
                    <path d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" fill="#007BFF" />
                    <path d="M22 12c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z" fill="#007BFF" />
                </svg>
            ),
        },
        // {
        //     id: `coln-1-collections`,
        //     label: 'eProcurement Settings',
        //     path: '/management/settings/e-procurements',
        //     isEnabled: true,
        //     svg: (
        //         <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        //             <circle cx="12" cy="12" r="9" fill="none" stroke="#007BFF" strokeWidth="2" />
        //             <path d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" fill="#007BFF" />
        //             <path d="M22 12c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z" fill="#007BFF" />
        //         </svg>
        //     ),
        // },
        // {
        //     id: `coln-1-collections`,
        //     label: 'Production Settings',
        //     path: '/management/settings/productions',
        //     isEnabled: true,
        //     svg: (
        //         <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        //             <circle cx="12" cy="12" r="9" fill="none" stroke="#007BFF" strokeWidth="2" />
        //             <path d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" fill="#007BFF" />
        //             <path d="M22 12c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z" fill="#007BFF" />
        //         </svg>
        //     ),
        // },
       
        {
            id: `coln-1-collections`,
            label: 'CMS Settings',
            path: '/management/settings/cms',
            isEnabled: true,
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="9" fill="none" stroke="#007BFF" strokeWidth="2" />
                    <path d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" fill="#007BFF" />
                    <path d="M22 12c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z" fill="#007BFF" />
                </svg>
            ),
        },
        {
            id: `coln-1-collections`,
            label: 'Organization Settings',
            path: '/management/settings/organizations',
            isEnabled: true,
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="9" fill="none" stroke="#007BFF" strokeWidth="2" />
                    <path d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" fill="#007BFF" />
                    <path d="M22 12c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z" fill="#007BFF" />
                </svg>
            ),
        },
        {
            id: `coln-1-Categories`,
            label: 'Global Settings',
            path: '/management/settings/global-settings/global',
            isEnabled: true,
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="9" fill="none" stroke="#007BFF" strokeWidth="2" />
                    <path d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" fill="#007BFF" />
                    <path d="M22 12c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z" fill="#007BFF" />
                </svg>
            ),
            subMenu: [
                {
                    id: `coln-1-collections`,
                    label: 'Global Settings',
                    path: '/management/settings/global-settings/global',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="9" fill="none" stroke="#007BFF" strokeWidth="2" />
                            <path d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" fill="#007BFF" />
                            <path d="M22 12c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z" fill="#007BFF" />
                        </svg>
                    ),
                },
                {
                    id: `coln-1-collections`,
                    label: 'Tags',
                    path: '/management/settings/global-settings/tags',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="9" fill="none" stroke="#007BFF" strokeWidth="2" />
                            <path d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" fill="#007BFF" />
                            <path d="M22 12c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z" fill="#007BFF" />
                        </svg>
                    ),
                },
            ],
        },
    ],
}
)
